module.exports = __webpack_public_path__ + "img/25.d41ce6c3.jpeg";